module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1207.a006b7e6.png";